import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

interface IConfirmSubmitDialogProps {
  open: boolean,
  title: string,
  content: string,
  onClose: () => void;
}

export const ConfirmSubmitDialog = (props: IConfirmSubmitDialogProps) => {
  return ( 
    <Dialog onClose={() => {props.onClose()}} aria-labelledby="submit-dialog-title" open={props.open}>
      <DialogTitle id="submit-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="submit-dialog-description">
          {props.content}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
